// begin file upload
document.addEventListener('DOMContentLoaded', function () {

    const fileChosen = document.getElementById('file');
    const formJob = document.getElementById('job-form');
    const formFile = document.getElementById('file-form');
    const fileId = document.getElementById('upload-file-id');
    const fileError = document.getElementById('upload-file-error');
    const butFileSubmit = document.getElementById('file-form-submit');
    const butMainSubmit = document.getElementById('main-form-submit');
    const clearResume = document.getElementById('clear-resume');
    const fileWarning = document.getElementById('FileUploadWarning');
    const uploadURL = document.getElementById('upload-url').value;
    const ariaLive = document.getElementById('file-selector-error');
    const checkOptIn = document.getElementById('OptInOutProxy');
    const hiddenOptIn = document.getElementById('OptInOut');

    function updateAriaLive(message) {
        ariaLive.textContent = message; // Set the new message
    }

    checkOptIn?.addEventListener('click', (event) => {
        if (checkOptIn.checked)
            hiddenOptIn.value = "true"
        else
            hiddenOptIn.value = "false"
        return true;
    });

    clearResume.addEventListener('click', (event) => {
        clearFileInput(fileChosen);
        clearFileAlert();
        updateAriaLive("File has been removed."); 
    });

    fileChosen.addEventListener('cancel', (event) => {
        clearFileAlert();
    });

    // we have two event listeners for fileChosen below??  10/10/24

    fileChosen.addEventListener('change', (event) => {
        // validate size and soft validate extension, hard validations on server side
        var fileName;
        var fileSize = 0;
        clearFileAlert();
        fileId.value = 0;
        return true;
    });

    fileChosen.addEventListener('change', (event) => {
        var fileName, fileSize = 0;
        try {
            fileName = event.target.files[0].name;
            fileSize = event.target.files[0].size;
        } catch {
            updateAriaLive("No file selected."); // Clear and set message if no file is selected
            return;
        }
        const extension = fileName.split('.').pop();
        if (extension !== "pdf") {
            updateAriaLive("Wrong file type. Please select a PDF file.");
            clearFileInput(fileChosen);
            setPrompt("Wrong file type. Please select a PDF file.");
            return false;
        } else if (fileSize > 1048576) { // 1 MB = 1048576 bytes
            updateAriaLive("File is too big. Please select a file that is no larger than 1MB.");
            clearFileInput(fileChosen);
            setPrompt("File is too big. Please select a file that is no larger than 1MB.");
            return false;
        }
        updateAriaLive("File selected successfully.");
        fileId.value = 0;
        return true;
    });

    butFileSubmit.addEventListener("click", (e) => {
        e.preventDefault();
        butFileSubmit.innerText = 'Sending...';
        trySubmit();
        butFileSubmit.innerText = 'Send';
        return false;
    });

    window.addEventListener('pageshow', () => { formJob.reset(); formFile.reset(); });
    function trySubmit() {
        var uploadId = fileId.value;
        fileError.value = "";
        if (hasFileToUpload(uploadId)) {
            uploadFile();
        }
        else {
            butMainSubmit.click();
        }
        return false;
    }

    function uploadFile() {
        var data = new FormData();
        var file = fileChosen.files[0];
        if (file) {
            data.append('file', file);
        }

        var xhr = new XMLHttpRequest();
        xhr.responseType = 'json';
        const status = xhr.status;
        xhr.open('POST', uploadURL, true);
        xhr.onerror = () => {
            console.log('Error occurred: ', xhr.statusText);
            if (status === 401) { // Unauthorized
                fileId.value = -1;
                setPrompt('You are not authorized to access this file resource.');
            } else if (status === 500) { // Internal Server Error
                fileId.value = -1;
                setPrompt('An unexpected error occurred while uploading the file to the server. Please try again later.');
            } else {
                fileId.value = -1;
                setPrompt('An unknown file upload error occurred.');
            }
        };
        xhr.onload = () => {
            var json = xhr.response;
            var fileStatus = json.fileStatus;
            var prompt = "success";
            if (json.success) {
                if (json.fileStatus == "Uploaded") { // "Uploaded" || "Invalid"
                    fileId.value = json.fileId; // send the fileID with the submission
                }
                else {
                    prompt = "There was an error uploading the file. Please check and try again.";
                }
            }
            else {
                clearFileInput(fileChosen);
                if (json.fileStatus == "Invalid") {
                    prompt = json.errors;
                }
                else {
                    prompt = "There was an error uploading the file. Please check and try again.";
                }
            }
            submitMainForm(prompt);
            return false;
        };
        xhr.send(data);
    }

    function submitMainForm(errorText) {
        fileError.value = (errorText == "success") ? "" : errorText;
        butMainSubmit.click();
        if (errorText != "success") {
            updateAriaLive(errorText);
            setPrompt(errorText);
            fileId.value = 0;
        }
        fileError.Value = "";
    }

    function hasFileToUpload(uploadId) {
        var fileName = fileChosen.value;
        var hasChosenAFile = !((!fileName) || (fileName.length === 0));
        return ((hasNoFileId(uploadId)) && (hasChosenAFile));
    }
    function hasNoFileId(thisId) {
        return ((!thisId) || (thisId.length === 0) || (thisId == "0"));
    }

    function clearFileAlert() {
        setPrompt("");
        updateAriaLive(""); // Clears the aria-live region message
    }
    function setPrompt(text) { // you can handle prompts here however and wherever you want to put them in the DOM
        var prompt = "ATTACH RESUME";
        if (text) {
            prompt = prompt + ": <a>" + text + "</a>";
            fileWarning.innerHTML = text;
            fileWarning.classList.remove('field-validation-valid');
            fileWarning.classList.remove('hidden');
            fileWarning.classList.add('field-validation-error');
        }
        else {
            fileWarning.innerHTML = "";
            fileWarning.classList.add('field-validation-valid');
            fileWarning.classList.remove('field-validation-error');
        }
    }
    function clearFileInput(ctrl) {
        try {
            ctrl.value = null;
        } catch (ex) { }
        if (ctrl.value) {
            ctrl.parentNode.replaceChild(ctrl.cloneNode(true), ctrl);
            fileId.value = "0";
        }
    }
});